<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>{{ data.title }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <cotecna-nf-form
      #naturalForm
      [config]="naturalFormConfig"
      [sections]="sections"
      [controls]="controls"
    >
    </cotecna-nf-form>
  </mat-card-content>
  <mat-card-actions align="end">
    <button id="cancel-add-form" (click)="cancel()" mat-button>CANCEL</button>
    <button
      id="save-form"
      [disabled]="!value"
      (click)="save()"
      mat-button
      color="primary"
    >
      SAVE
    </button>
  </mat-card-actions>
</mat-card>
